import { stringify } from 'qs';

export const buildQueryString = (params: Record<string, unknown>) =>
    stringify(params, { arrayFormat: 'brackets' }).replace(/%3A/g, ':').replace(/%2B/g, '+');
